import { Controller } from '@hotwired/stimulus';
import Chart from 'chart.js/auto';

// Connects to data-controller="doughnut-chart"
export default class extends Controller {
	static values = {
		id: String,
		labels: Array,
		data: Array,
		percentage: Array
	};

	static targets = ['canvas'];

	connect() {
		this.initChart(this.idValue);
	}

	getOrCreateLegendList(_chart, id) {
		const legendContainer = document.getElementById(id);
		let listContainer = legendContainer.querySelector('ul');

		if (!listContainer) {
			listContainer = document.createElement('ul');
			listContainer.style.margin = 0;
			listContainer.style.padding = 0;

			legendContainer.appendChild(listContainer);
		}

		return listContainer;
	}

	htmlLegendPlugin() {
		return {
			id: 'htmlLegend',
			afterUpdate: (chart, args, options) => {
				const ul = this.getOrCreateLegendList(chart, options.containerID);

				// Remove old legend items
				while (ul.firstChild) {
					ul.firstChild.remove();
				}
				const items = chart.options.plugins.legend.labels.generateLabels(chart);

				items.forEach((item) => {
					const li = document.createElement('li');
					li.style.alignItems = 'center';
					li.style.cursor = 'pointer';
					li.style.marginLeft = '10px';

					li.onclick = () => {
						const { type } = chart.config;
						if (type === 'pie' || type === 'doughnut') {
							// Pie and doughnut charts only have a single dataset and visibility is per item
							chart.toggleDataVisibility(item.index);
						} else {
							chart.setDatasetVisibility(
								item.datasetIndex,
								!chart.isDatasetVisible(item.datasetIndex)
							);
						}
						chart.update();
					};

					// Color box
					const boxSpan = document.createElement('span');
					boxSpan.style.background = item.fillStyle;
					boxSpan.style.borderColor = item.strokeStyle;
					boxSpan.style.borderWidth = item.lineWidth + 'px';
					boxSpan.style.display = 'inline-block';
					boxSpan.style.height = '20px';
					boxSpan.style.marginRight = '10px';
					boxSpan.style.width = '20px';

					// Text
					const textContainer = document.createElement('p');
					textContainer.style.color = item.fontColor;
					textContainer.style.margin = '0px';
					textContainer.style.padding = '0px';
					textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
					const { type } = chart.config;
					const total =
						type === 'pie' || type === 'doughnut'
							? ' (' + chart.data.datasets[0].data[item.index] + ')'
							: '';

					const text = document.createTextNode(item.text + total);
					textContainer.appendChild(text);

					li.appendChild(boxSpan);
					li.appendChild(textContainer);
					ul.appendChild(li);
				});
			}
		};
	}

	initChart(chartId) {
		const tootltipItems = (tooltipItems) => {
			let percentage = '';
			tooltipItems.forEach((tooltipItem) => {
				percentage += tooltipItem.dataset.percentage[tooltipItem.dataIndex];
			});
			return percentage ? ' ' + percentage + '%' : '';
		};

		const chart = new Chart(this.canvasTarget, {
			type: 'doughnut',
			data: {
				labels: this.labelsValue,
				datasets: [
					{
						data: this.dataValue,
						backgroundColor: ['#3e9cd9', '#c41330', '#3de275', '#e15b71', '#bfb5b6', '#028ee9'],
						percentage: this.percentageValue
					}
				]
			},
			options: {
				plugins: {
					tooltip: {
						callbacks: {
							footer: tootltipItems
						}
					},
					htmlLegend: {
						containerID: `legend${chartId}`
					},
					legend: {
						display: false
					}
				},
				responsive: true,
				legend: false
			},
			plugins: [this.htmlLegendPlugin(chartId)]
		});
		return chart;
	}
}
